import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

// ======================== Image MiniGame QLT Functions ========================

/**
 * Lấy tất cả Image MiniGame QLT
 */
export const fetchLoadingImageMiniGameQLT = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/imageMiniGame/image`);
    return response.data.images || [];
  } catch (error) {
    console.error('Error fetching images:', error);
    throw error.response?.data || { message: 'Failed to fetch images' };
  }
};

/**
 * Upload Image MiniGame QLT
 */
export const fetchUploadImageMiniGameQLT = async (file) => {
  try {
    const formData = new FormData();
    formData.append('url', file);

    const response = await axios.post(`${BASE_URL}/api/imageMiniGame/image`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error.response?.data || { message: 'Failed to upload image' };
  }
};

/**
 * Sửa Image MiniGame QLT
 */
export const fetchEditImageMiniGameQLT = async (id, formData) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageMiniGame/image/${id}`, formData);
    return response.data.image;
  } catch (error) {
    console.error('Error editing image:', error);
    throw error.response?.data || { message: 'Failed to edit image' };
  }
};

/**
 * Xóa Image MiniGame QLT
 */
export const fetchDeleteImageMiniGameQLT = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL}/api/imageMiniGame/image/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error.response?.data || { message: 'Failed to delete image' };
  }
};

/**
 * Toggle Status Image MiniGame QLT
 */
export const fetchToggleStatusImageMiniGame = async (id) => {
  try {
    const response = await axios.put(`${BASE_URL}/api/imageMiniGame/image/status/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error toggling image status:', error);
    throw error.response?.data || { message: 'Failed to toggle status' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingImageMiniGameQLT,
  fetchUploadImageMiniGameQLT,
  fetchEditImageMiniGameQLT,
  fetchDeleteImageMiniGameQLT,
  fetchToggleStatusImageMiniGame,
};

